import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { Link } from "react-router-dom";
import { ORANGE, BLACK } from "./global_varibles";

function CreateFooterPage() {
  const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/" },
    { label: "Prices", path: "/prices" },
    { label: "Login", path: "/login" },
  ];

  const socialMediaIcons = [
    { Icon: FacebookIcon, url: "https://www.facebook.com/MuftyKare/" },
    { Icon: InstagramIcon, url: "https://instagram.com" },
    { Icon: XIcon, url: "https://x.com" },
    { Icon: YouTubeIcon, url: "https://www.youtube.com/watch?v=HksdCyr8pfQ" },
  ];

  const contactInfo = [
    { Icon: CallIcon, text: "+91-7075540540" },
    { Icon: CallIcon, text: "+91-7075232425" },
    { Icon: EmailIcon, text: "nanaaji@muftykare.com" },
  ];

  const googleMapsUrl = "https://www.google.com/maps/place/MuftyKare+DryClean%7C+Laundry+%7CPickup+%26+Delivery+%7C+Vizag/@17.7376629,83.3060535,17z/data=!3m1!4b1!4m6!3m5!1s0x3a394332f9651fe3:0xb5df1e30e5ee8a3f!8m2!3d17.7376629!4d83.3060535!16s%2Fg%2F11bw82m834?entry=ttu&g_ep=EgoyMDI1MTExMi4wIKXMDSoASAFQAw%3D%3D";

  return (
    <footer className="w-full relative">
      {/* Gradient background */}
      <div className="absolute inset-0" style={{ backgroundColor: BLACK }} />
      <div className="relative max-w-6xl mx-auto px-4 py-10 border-t border-white/10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Quick Links */}
          <div>
            <h3 className="text-white text-xl font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-1 ml-1">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="!text-gray-300 visited:text-gray-300 no-underline hover:text-orange-500 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500/40 rounded-sm"
                    style={{ color: '#d1d5db' }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-xl font-semibold mb-3">Contact Info</h3>
            <ul className="space-y-2 ml-1">
              {contactInfo.map(({ Icon, text }, idx) => (
                <li
                  key={`${text}-${idx}`}
                  className="flex items-center gap-2 text-gray-300"
                >
                  <Icon
                    fontSize="small"
                    sx={{ color: ORANGE }}
                    className="shrink-0"
                  />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Locate Us */}
          <div>
            <h3 className="text-white text-xl font-semibold mb-3">Locate Us</h3>
            <div className="ml-1">
              <address className="not-italic text-gray-300 leading-relaxed mb-3">
                Door No. 50-50-27/5 <br />
                Beside Vishnu Honda Balaji Hills <br />
                NH-16, Balayya Sastri Layout <br />
                Seethammadhara <br />
                Visakhapatnam - 530 013 <br />
                Andhrapradesh.
              </address>
              
              {/* Google Maps Link */}
              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm font-medium text-gray-200 transition-all hover:-translate-y-0.5 hover:border-orange-400/60 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-orange-500/40"
              >
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-orange-500 text-white shadow-sm ring-1 ring-orange-400/40 transition-colors group-hover:bg-orange-600">
                  <LocationOnOutlinedIcon fontSize="small" className="!text-white" />
                </span>
                <span className="!text-white">View on Google Maps</span>
              </a>
            </div>
          </div>

          {/* Follow Us */}
          <div>
            <h3 className="text-white text-xl font-semibold mb-3">Follow Us On</h3>
            <div className="grid grid-cols-4 gap-2 ml-1">
              {socialMediaIcons.map(({ Icon, url }, idx) => (
                <a
                  key={idx}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-center p-2 rounded-lg !text-gray-300 hover:!text-orange-500 hover:bg-white/5 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500/40"
                  aria-label="Social link"
                >
                  <Icon
                    fontSize="medium"
                    color="inherit"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-6 border-t border-white/10 text-center">
          <p className="text-gray-400 text-sm">
            © 2015 MuftyKare
          </p>
        </div>
      </div>
    </footer>
  );
}

export default CreateFooterPage;
